import { Button } from '@mui/material';
import React from 'react';

const ButtonGlimmer: React.FC<{ addClass?: string }> = ({ addClass }) => {
  return <Button className={`glimmer_element ${addClass}`} />;
};

export default ButtonGlimmer;
